import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { GridComponent } from '../grid/grid.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NgxLiveViewService } from '../ngx-live-view.service';
import { CustomOption } from '../models/IOption';
import { ViewListModel } from '../models/ViewListModel';
import { VideoGridService } from './video-grid.service';

declare var $: any;
export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}
@Component({
  selector: 'lib-video-grid',
  templateUrl: './video-grid.component.html',
  styleUrls: ['./video-grid.component.css'],
})

export class VideoGridComponent implements OnInit, AfterViewInit {

  @Input() theme: string = 'light';
  @Input() inputPlayVideo: any;
  @Input() options: CustomOption[] = [];
  @Input() ViewList: any[] = [];
  @Input() gridMode: string = 'general';
  @Input() playerServerIp: string = '';
  @Input() streamerIp: string = '';
  @Input() playDuplicate: boolean = false;
  @Input() gridView : ViewListModel = {
    id: 4,
    Text: '2x2',
    heading: '4 cameras',
    Rows: 2,
    Cols: 2,
  } as ViewListModel;
  @Output() VideoStarted: EventEmitter<any> = new EventEmitter<any>();
  @Output() ClearGridEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() VideoClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() FunctionClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() DimensionChange : EventEmitter<any> = new EventEmitter<any>();
  
  @ViewChild('spring') springTemplate = {} as TemplateRef<any>;
  @ViewChild('appGrid') appGrid: GridComponent = {} as GridComponent;

  //Internal Properties
    
  showViewList: boolean = false;
  gridSubject: Subject<any> = new Subject<any>();
  eventDataSubject: Subject<any> = new Subject<any>();
  selfheight: number = 0;
  selfwidth: number = 0;
  optionsHeight: number = 0;

  _ViewList: ViewListModel[] = [
    {
      id: 1,
      Text: '1x1',
      heading: '1 camera',
      Rows: 1,
      Cols: 1,
    },
    {
      id: 2,
      Text: '2x1',
      heading: '2 cameras',
      Rows: 2,
      Cols: 1,
    },
    {
      id: 3,
      Text: '1 + 2',
      heading: '3 cameras',
      Rows: 2,
      Cols: 2,
      hasSpecial: true,
      SpecialElement: 0,
      SEWidth: 2,
      SEHeight: 1,
      NumberofTiles: 3,
    },
    {
      id: 4,
      Text: '2x2',
      heading: '4 cameras',
      Rows: 2,
      Cols: 2,
    },
    {
      id: 5,
      Text: '1 + 5',
      heading: '6 cameras',
      Rows: 3,
      Cols: 3,
      hasSpecial: true,
      SpecialElement: 0,
      SEWidth: 2,
      SEHeight: 2,
      NumberofTiles: 6,
    },
    {
      id: 6,
      Text: '3x3',
      heading: '9 cameras',
      Rows: 3,
      Cols: 3,
    },
    {
      id: 7,
      Text: '1 + 7',
      heading: '8 cameras',
      Rows: 4,
      Cols: 4,
      hasSpecial: true,
      SpecialElement: 0,
      SEWidth: 3,
      SEHeight: 3,
      NumberofTiles: 8,
    },
    {
      id: 8,
      Text: '4x4',
      heading: '16 cameras',
      Rows: 4,
      Cols: 4,
    },
    {
      id: 9,
      Text: '10x10',
      heading: '100 cameras',
      Rows: 10,
      Cols: 10,
    },
    {
      id: 10,
      Text: '15x15',
      heading: '225 cameras',
      Rows: 15,
      Cols: 15,
    },
    {
      id: 11,
      Text: '20x20',
      heading: '400 cameras',
      Rows: 20,
      Cols: 20,
    }
  ];

  ThemeScheme: any = {
    dark: {
      background: '#303030',
      border: 'rgba(255,255,255,.2)',
      color: '#fff',
    },
    light: {
      background: '#fff',
      border: 'black',
      color: '#000',
    },
  };

  borderColor = 'rgba(255,255,255,.2)';
  SelectedView: any = this._ViewList[3];
  searchText: string = '';
  search: boolean = false;
  Rows: number = 2;
  Cols: number = 2;
  width: number = 0;
  numbers: number[] = [1, 2, 3, 4];
  cameras: any[] = [];
  showToolbar: boolean = false;
  currentVideoFit: string = 'original';
  videoFit = [
    { name: 'Fill', value: 'fill' },
    { name: 'Fit', value: 'scale-down' },
    { name: 'Stretch', value: 'cover' },
    { name: 'Original', value: 'contain' },
  ];

  IsDetailsHiddenFromGrid: boolean = false;
  GridRowRatio = 1.3;

  tiles: Tile[] = [
    { text: 'One', cols: 3, rows: 1, color: 'lightblue' },
    { text: 'Two', cols: 1, rows: 2, color: 'lightgreen' },
    { text: 'Three', cols: 1, rows: 1, color: 'lightpink' },
    { text: 'Four', cols: 2, rows: 1, color: '#DDBDF1' },
  ];


  constructor(
    private _NgxLiveViewService: NgxLiveViewService,
    private _bottomSheet: MatBottomSheet,
    private _videoGridService: VideoGridService
  ) { }

  ngOnInit(): void {

    this.borderColor = this.ThemeScheme[this.theme].border;
    
    /* Checking if the user has clicked outside of the view list. If so, it will hide the view list.
     */
    $('html').click((evt: any) => {
      if (evt.target.id == 'view_list') return;
      //For descendants of menu_content being clicked, remove this check if you do not want to put constraint on descendants.
      if ($(evt.target).closest('#view_list').length) return;

      if (this.showViewList) {
        this.showViewList = false;
      }
    });

    /* Getting the height and width of the parent grid. */
    this.selfheight = document.getElementById('parentGrid')!.offsetHeight - 1;
    this.selfwidth = document.getElementById('parentGrid')!.offsetWidth - 1;
    console.log('height = ' + this.selfheight + ' , width = ', +this.selfwidth);

     /* Setting Input Rows and Cols from App Component. */
     this.Rows = this.gridView.Rows;
     this.Cols = this.gridView.Cols;
     this.SelectedView = this.gridView;
    
  }

  ngAfterViewInit(): void {

      this._NgxLiveViewService.videoelementSubject.subscribe(data => {
        if (this.gridMode == 'general') {
        console.log(data);

        /* Checking if the data.parentNode is null or undefined. If it is, it will call the play method
       with the data object. If it is not null or undefined, it will call the play method with the
       data.nodeData object. */

        if (data.parentNode == null || data.parentNode == undefined) {
          this.play(
            data,
            'LIVE',
            data.eventObject,
            data?.color,
            data?.timeRange,
            data?.byAction
          );
        } else {
          this.play(
            data.nodeData,
            'LIVE',
            data.nodeData.eventObject,
            data.nodeData?.color,
            data.nodeData?.timeRange,
            data.nodeData?.byAction,
            data.parentNode
          );
        }
      }
      });
    
    this._ViewList = this._ViewList.concat(this.ViewList);

      this._NgxLiveViewService.eventsCards.subscribe(data => {
        if (this.gridMode == 'FRS') {
        if (data == null || data == undefined) {
          this.fill(
            data
          );
        } else {
          this.fill(
            data,
          );
        }
      }
      });
      this._videoGridService.videoGridResizer$.subscribe(() => {
        this.resizer();
      });
      
  }


  /**
   * If the theme is dark, change it to light, otherwise change it to dark
   */
  ChangeTheme() {
    this.theme = this.theme == 'dark' ? 'light' : 'dark';
    this.borderColor = this.ThemeScheme[this.theme].border;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gridMode) {
      console.log(this.gridMode);
    }
  }
  /**
   *Here we find the index of the selected view from the ViewList array and then assign the Rows
   * and Cols of the selected view to the Rows and Cols of the appGrid.
   * @param {any} view - any - selected configuration from the view list
   */
  view_selected(view: any) {
    console.log(view);
    this.showViewList = false;
    // get index with view.heading from ViewList
    this.SelectedView = this.ViewList.find(x => x.heading == view.heading);
    if (this.appGrid) {
      this.appGrid.GridConfig = this.SelectedView;
      this.appGrid.Rows = this.SelectedView.Rows;
      this.appGrid.Cols = this.SelectedView.Cols;
      this.appGrid.ChangeLayout(
        this.SelectedView.SpecialElement,
        this.SelectedView.SEHeight,
        this.SelectedView.SEWidth
      );
    } else {
      this.Rows = view.Rows;
      this.Cols = view.Cols;
    }
    // this.saveLayout();
  }

  /**
   * If the appGrid exists, set the Rows and Cols properties of the appGrid to the Rows and Cols
   * properties of the view (configuation layout), and then call the ChangeLayout function of the appGrid, passing in the
   * SpecialElement, SEHeight, and SEWidth properties of the view.
   * @param {number} index - the index of the view in the ViewList array
   */

  viewSelected(index: number) {
    this.showViewList = false;
    let view = this._ViewList[index];
    this.SelectedView = this._ViewList[index];
    if (this.appGrid) {
      this.appGrid.GridConfig = this.SelectedView;
      this.appGrid.Rows = view.Rows;
      this.appGrid.Cols = view.Cols;
      this.appGrid.ChangeLayout(
        view.SpecialElement,
        view.SEHeight,
        view.SEWidth
      );
    } else {
      this.Rows = view.Rows;
      this.Cols = view.Cols;
    }
  }

  /**
   * "This function is called when a user clicks on a camera in the UI. It then sends a message to the
   * gridSubject, which is a BehaviorSubject. The gridSubject is subscribed to by the grid component,
   * which then adds a new node to the grid."
   * </code>
   * @param resource - { time_out: any; id: any; resourceName: any; info: any; },
   * @param {string} mode - "LIVE" or "PLAYBACK"
   * @param {any} [eventObject] - this is the event object that is passed to the video component.
   * @param {any} [color] - string
   * @param {any} [timeRange] - if any time range
   * @param {any} [byAction] - boolean
   * @param {string} [parentNode] - string - this is the id of the parent node
   */

  play(
    //resource: { time_out: any; id: any; resourceName: any; info: any },
    resource: any,
    mode: string,
    eventObject?: any,
    color?: any,
    timeRange?: any,
    byAction?: any,
    parentNode?: string
  ) {
    var time_out = resource?.time_out;
    let rightAvailable: boolean = true;
    //rightAvailable = this.licenceService.checkLicenceAndRights(NavigationConstString.DashboardRights, Enum_UserRights.ViewCameraFeed)
    if (rightAvailable) {
      if (mode == 'LIVE') {
        this.gridSubject.next({
          nodeData: {
            id: Math.round(Math.random() * 1000),
            camera: resource,
            cameraId: resource.id,
            cameraName: resource.resourceName,
            time_out: time_out,
            playbackMode: mode,
            ComponentName: 'Video',
            eventObject: eventObject,
            color: color,
            byAction: byAction,
            info: resource.info,
          },
          parentNode: parentNode,
        });
      } else {
        this.gridSubject.next({
          nodeData: {
            id: Math.round(Math.random() * 1000),
            cameraId: resource.id,
            cameraName: resource.resourceName,
            time_out: time_out,
            playbackMode: mode,
            ComponentName: 'Video',
            eventObject: eventObject,
            color: color,
            timeRange: timeRange,
            byAction: byAction,
            info: resource.info,
          },
          parentNode: parentNode,
        });
      }
    }
  }

  /**
   * The function is called when the user clicks the Clear Grid button. The function emits an event to
   * the parent component. The parent component then calls the clearGrid() function in the child
   * component
   */
  onClearGrid() {
    this.ClearGridEvent.emit();
  }

  /**
   * The function is called when the user clicks on the "Clear Grid" button. The function calls the
   * closeGridCard() function in the appGrid component.
   */
  clearGrid() {
    this.appGrid.closeGridCard();
  }

  /**
   * When an element is removed from the grid, the inputPlayVideo variable is set to undefined and the
   * onVideoClosed event is emitted.
   * @param {any} element - any - the element that was removed
   */
  onElementRemovedFromGrid(element: any) {
    console.log(element);
    //console.log('onElementRemovedFromGrid');
    this.inputPlayVideo = undefined;
    this.VideoClosed.emit(element);
  }

  /**
   * When the video starts, emit the event to the parent component (application).
   * @param {any} event - any
   */
  VideoGridVideoStarted(event: any) {
    //console.log('onVideoStarted');
    this.VideoStarted.emit(event);
  }

  /**
   * If the appGrid exists, then we can toggle the fullScreen.
   */
  toggleFullScreen() {
    if (this.appGrid) {
      this.appGrid.fullScreen();
    }
  }

  /**
   * If there is any selected elements in the grid. Then, we change the objectFit property of the selected elements.
   * else we change the objectFit property of all the elements in the grid. The video elements have an id like this: videoContainer_+'id'+_video.
   * If the selectedGridElements array is empty, then all the video elements will be selected.
   * @param {string} videoFit - string - the video fit type (contain, cover, fill, none, scale-down, or inherit)
   */
  changeAllVideoFit(videoFit: string) {
    this.currentVideoFit = videoFit;
    if (this.appGrid) {
      // // find all the elements video with id like id="videoContainer_+'id'+_video"
      let videoElements = document.querySelectorAll(
        'video[id^="videoContainer_"][id$="_video"]'
      );
      // // if there is any selected elements in the grid
      if (this.appGrid.selectedGridElements.length > 0) {
        for (
          var element = 0;
          element < this.appGrid.selectedGridElements.length;
          element++
        ) {
          videoElements.forEach(x => {
            if (
              x.id ==
              'videoContainer_' +
              this.appGrid.selectedGridElements[element] +
              '_video'
            ) {
              let video = x as HTMLVideoElement;
              video.style.objectFit = videoFit;
            }
          });
        }
      } else {
        // // find all the elements video with id like id="videoContainer_+'id'+_video"
        if (videoElements.length > 0) {
          videoElements.forEach(element => {
            let video = element as HTMLVideoElement;
            video.style.objectFit = this.currentVideoFit;
          });
        }
      }
    }
  }

  /**
   * It finds all the divs with id header_+'id' and footer_+'id' and changes the height of the video
   * containers with id appWebPlayer_+'id'.
   * If there are no selected elements, it changes the height of all the video containers.
   * else it changes the height of the video containers of the selected elements.
   */
  stichVideos() {
    this.IsDetailsHiddenFromGrid = !this.IsDetailsHiddenFromGrid;
    if (this.appGrid) {
      // inside div with id parentGridLiveView find all divs with id header_+'id' and footer_+'id'
      let headerElements = document.querySelectorAll(
        'div[id^="outer"] div[id^="header_"]'
      );
      let footerElements = document.querySelectorAll(
        'div[id^="outer"] div[id^="footer_"]'
      );

      // change the height of the video containers with id appWebPlayer_+'id'
      let videoContainerElements = document.querySelectorAll(
        'div[id^="appWebPlayer_"]'
      );

      if (this.appGrid.selectedGridElements.length > 0) {
        for (
          var element = 0;
          element < this.appGrid.selectedGridElements.length;
          element++
        ) {
          this.stich(headerElements, 'header_', element);
          this.stich(footerElements, 'footer_', element);
          this.stich(videoContainerElements, 'appWebPlayer_', element);
        }
      } else {
        this.stich(headerElements, 'all', -1);
        this.stich(footerElements, 'all', -1);
        this.stich(videoContainerElements, 'all', 0);
      }
    }
  }

  /**
   * If there are no selected Grid present if the element is equal to 0, then for each video in Grid, set the parameter to the
   * then set the height of the parameter to 100% and if the element is not equal to 0, then toggle the display of the HTML Element.
   * else for selcted Grid, if the element is equal to 0, then set height else display of video element
   * @param List - NodeListOf<any> : Either of the following: headerElements, footerElements, videoContainerElements;
   * @param {string} str - string = "all" or "appWebPlayer_"
   * @param {number} element - number =&gt; this is the index of the selected element in the grid.
   */
  stich(List: NodeListOf<any>, str: string, element: number) {
    if (str != 'all') {
      List.forEach(x => {
        if (x.id == str + this.appGrid.selectedGridElements[element]) {
          let parameter = x as HTMLElement;
          if (str == 'appWebPlayer_') {
            parameter.style.height = this.IsDetailsHiddenFromGrid
              ? '100%'
              : 'calc(100% - 40px)';
          } else {
            parameter.style.display = this.IsDetailsHiddenFromGrid
              ? 'none'
              : 'flex';
          }
        }
      });
    } else {
      List.forEach(x => {
        let parameter = x as HTMLElement;
        if (element == 0) {
          parameter.style.height = this.IsDetailsHiddenFromGrid
            ? '100%'
            : 'calc(100% - 40px)';
        } else {
          parameter.style.display = this.IsDetailsHiddenFromGrid
            ? 'none'
            : 'flex';
        }
      });
    }
  }

  /**
   * The openBottomSheet() function opens the bottom sheet which include functions for total video Grid.
   */
  openBottomSheet(): void {
    this._bottomSheet.open(this.springTemplate);
  }

  /**
   * If the grid is selected, then for each selected grid element, click the snapshot button.
   * If the grid is not selected, then click the snapshot button for each element.
   */
  clickSnapshot() {
    if (this.appGrid) {
      if (this.appGrid.selectedGridElements.length > 0) {
        for (var i = 0; i < this.appGrid.selectedGridElements.length; i++) {
          this.appGrid.alerts.forEach(element => {
            if (element.idx == this.appGrid.selectedGridElements[i]) {
              element.clickSnapShot();
            }
          });
        }
      } else {
        this.appGrid.alerts.forEach(element => {
          element.clickSnapShot();
        });
      }
    }
  }

  /**
   * This function is called by the Video-Grid component and it sends a message to the
   * NgxLiveViewService, which is then received by the LiveView component.
   * @param {any} callback - This is the function that you want to call from the parent component.
   */
  videogridfunctionCallback(callback: any) {
    this._NgxLiveViewService.notificationemittor.next({
      source: 'videogrid',
      message: callback,
    });
  }

  fill(data: any) {
    this.eventDataSubject.next(data);
  }
  /**
 * The function resizer() is called when the window is resized. It checks to see if the grid exists,
 * and if it does, it calls the resizeGrid() function on the grid
 */
  resizer() {
    if (this.appGrid) {
      this.appGrid.resizeGrid();
    }
  }

  onDimensionChange(event: any) {
    this.DimensionChange.emit(event);
  }
}
